import React from "react";
import PropTypes from "prop-types";
import { EditorState, Modifier } from "draft-js";

const CustomComponent = ({ editorState, onChange, templateKey, type }) => {

  const addTemplateKeys = (object) => {
    if (object){
      const contentState = Modifier.replaceText(
        editorState.getCurrentContent(),
        editorState.getSelection(),
        `{{ ${object} }}`,
        editorState.getCurrentInlineStyle()
      );
      onChange(EditorState.push(editorState, contentState, "insert-characters"));
    }

  };

  return (
    <>
    {templateKey[type] ? templateKey[type].map(function(object, i){
          return <div style={{margin: '5px'}} key={`tag-${i}`} onClick={() => addTemplateKeys(object)}><span className="responded general">{object}</span></div>;
    }): ''} 
    </>
  );
};

CustomComponent.propTypes = {
  onChange: PropTypes.func,
  editorState: PropTypes.object,
  templateKeys: PropTypes.object,
};

export default CustomComponent;
